import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { Badge } from 'DesignSystem/ui/badge';

type Props = {
  row: Row<UpstreamEvent>;
};

export function LocationsImpacted({ row }: Props) {
  const count = row.original.locations_impacted ?? 0;
  return <Badge variant="outline">{count}</Badge>;
}
